import styled from "styled-components";

export const Content = styled.img`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  
`